const formatHarga = (num: string) => {
    return num.replace(/\./g, "").replace(/,/g, ".");
};

export default formatHarga;
